import { render, staticRenderFns } from "./BackupRestore.vue?vue&type=template&id=4ae28ccb"
import script from "./BackupRestore.vue?vue&type=script&lang=js"
export * from "./BackupRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports